import { createZustandContext } from '#pplx/frontend/zustand-context/createZustandContext.js';
import { create } from 'zustand';
export const dest = createZustandContext('HomepageComponentsContext', (initialValues) => {
    return create((set) => ({
        homepageTitle: initialValues?.homepageTitle || '',
        actions: {
            onHomepageTitleChange: (homepageTitle) => {
                set({ homepageTitle });
            },
        },
    }));
});
//# sourceMappingURL=HomepageComponentsProviderShared.js.map